import { render, staticRenderFns } from "./NotificationCounter.vue?vue&type=template&id=2d45c2cc&scoped=true"
import script from "./NotificationCounter.vue?vue&type=script&lang=js"
export * from "./NotificationCounter.vue?vue&type=script&lang=js"
import style0 from "./NotificationCounter.vue?vue&type=style&index=0&id=2d45c2cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d45c2cc",
  null
  
)

export default component.exports